<template>
  <div class="flex flex-col justify-between h-full">
    <CustomLink
      :url="link"
      :type="LINK_TYPE.NoStyle"
      @link-click="handleCardClick"
    >
      <div
        class="flex flex-col"
      >
        <TwicpicsImage
          :src="image"
          :alt="imageAlt"
          :width="SIMPLIFIED_CARD.IMAGE_WIDTH"
          :height="SIMPLIFIED_CARD.IMAGE_HEIGHT"
        />
        <p class="line-clamp-2 font-semibold text-sm">
          {{ title }}
        </p>
      </div>
    </CustomLink>
    <EnergyRating
      v-if="energyRating"
      :energy-rating="energyRating"
      :size="ENERGY_RATING_SIZE.MEDIUM"
    />
    <CustomLink
      :url="link"
      :type="LINK_TYPE.NoStyle"
      @link-click="handleCardClick"
    >
      <ProductFinalPrice
        :final-price="isDiscounted ? discountedPrice : fullProductPrice"
        :is-discounted="isDiscounted"
        class="text-2xl"
      />
    </CustomLink>
  </div>
</template>

<script lang="ts">

import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import type { EnergyRatingDetails } from '~~/types/components/EnergyRating/EnergyRatingDetails';
import { ENERGY_RATING_SIZE } from '~~/constants/energyRating';
import { SIMPLIFIED_CARD } from '~~/constants/productCard';

import type { ProductCategories } from '~~/types/product/ProductCategories';

export default defineComponent({
  name: 'MiniProductCard',

  props: {
    link: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    productBoxTypeTag: {
      type: String,
      required: true,
    },
    fullProductPrice: {
      type: Number,
      required: true,
    },
    energyRating: {
      type: Object as PropType<Maybe<EnergyRatingDetails>>,
      default: (): Maybe<EnergyRatingDetails> => null,
    },
    sku: {
      type: String,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    discountedPrice: {
      type: Number,
      default: null,
    },
    brand: {
      type: String,
      default: '',
    },
    categories: {
      type: [Object, String] as PropType<ProductCategories>,
      required: true,
    },
  },
  emits: ['product-clicked'],
  setup(props, { emit }) {

    const { trackClickProductBox } = useGtmEvents();
    const i18n = useI18n();

    const isDiscounted = computed(() => {

      return props.discountedPrice > 0;
    
    });

    const imageAlt = computed(() => {

      return `${props.title} - ${i18n.t('Product Image')}`;
    
    });

    const handleCardClick = () => {

      emit('product-clicked');
      trackClickProductBox({
        boxType: props.productBoxTypeTag,
        product: {
          sku: props.sku,
          name: props.title,
          currency: props.currency,
          discountedPrice: props.discountedPrice,
          brand: props.brand,
          price: props.fullProductPrice,
          categories: props.categories,
        },
      });
    
    };

    return {
      LINK_TYPE,
      ENERGY_RATING_SIZE,
      SIMPLIFIED_CARD,
      handleCardClick,
      isDiscounted,
      imageAlt,
    };
  
  },
});

</script>
